import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ExternalLink } from 'lucide-react';
import { Product } from '../utils/data';
interface ProductCardProps {
  product: Product;
  featured?: boolean;
}
const ProductCard: React.FC<ProductCardProps> = ({
  product,
  featured = false
}) => {
  // Calculate average rating
  const averageRating = product.reviews.reduce((sum, review) => sum + review.rating, 0) / product.reviews.length;
  return <div className={`bg-white rounded-lg shadow-md overflow-hidden flex flex-col ${featured ? 'h-full' : ''}`} data-id="element-50">
      <div className="relative h-48 overflow-hidden" data-id="element-51">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-52" />
        <div className="absolute top-2 right-2 bg-brand-600 text-white text-xs font-semibold px-2 py-1 rounded-full" data-id="element-53">
          Dietitian Approved
        </div>
      </div>
      <div className="p-4 flex-grow flex flex-col" data-id="element-54">
        <div className="flex-grow" data-id="element-55">
          <h3 className="text-lg font-semibold mb-1 text-gray-900" data-id="element-56">
            {product.name}
          </h3>
          <p className="text-sm text-gray-600 mb-2" data-id="element-57">
            {product.shortDescription}
          </p>
          <div className="flex items-center mb-2" data-id="element-58">
            <div className="flex text-yellow-400" data-id="element-59">
              {[...Array(5)].map((_, i) => <Star key={i} className={`h-4 w-4 ${i < Math.round(averageRating) ? 'fill-current' : 'stroke-current fill-transparent'}`} data-id="element-60" />)}
            </div>
            <span className="text-xs text-gray-500 ml-1" data-id="element-61">
              ({product.reviews.length} dietitian{' '}
              {product.reviews.length === 1 ? 'review' : 'reviews'})
            </span>
          </div>
        </div>
        <div className="mt-2" data-id="element-62">
          <div className="flex items-center justify-between" data-id="element-63">
            <span className="font-bold text-gray-900" data-id="element-64">{product.price}</span>
            <div className="flex space-x-2" data-id="element-65">
              <Link to={`/products/${product.id}`} className="text-brand-600 hover:text-brand-700 text-sm font-medium" data-id="element-66">
                View Details
              </Link>
              <a href={product.purchaseLink} target="_blank" rel="noopener noreferrer" className="flex items-center text-brand-600 hover:text-brand-700 text-sm font-medium" data-id="element-67">
                Buy <ExternalLink className="h-3 w-3 ml-1" data-id="element-68" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ProductCard;